import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { cardButton, SanityCardButton } from './buttonRow';
import { form, SanityForm } from './form';
import { formConfirmation, SanityFormConfirmation } from './formConfirmation';
import { link, SanityLink } from './link';
import { media, SanityMedia } from './media';

export const SanityHeroSplit = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('heroSplit'),
  _key: z.string(),
  theme: z.enum(['purple', 'charcoal', 'white']),
  mediaPosition: z.enum(['left', 'right']),
  backgroundPattern: z.string().optional().nullable(),
  eyebrow: z.string().optional().nullable(),
  title: z.string(),
  bodyCopy: SanityBasicText.optional().nullable(),
  ctaMode: z.enum(['buttons', 'standardForm', 'redirectForm']),
  buttons: z.array(SanityCardButton).optional().nullable(),
  form: SanityForm.optional().nullable(),
  formConfirmation: SanityFormConfirmation.optional().nullable(),
  formFunnel: z.enum(['contact', 'rails']).optional().nullable(),
  primaryButtonLabel: z.string().optional().nullable(),
  secondaryButton: SanityLink.optional().nullable(),
  media: SanityMedia,
  mascot: z
    .enum([
      'none',
      'peek-teal-ul-then-lime-lr',
      'peek-lime-lr',
      'peek-purple-ll',
      'bounce-teal-bottom-to-cta',
      'roll-purple-bottom',
      'peek-purple-ul-then-teal-lc',
    ])
    .optional()
    .nullable(),
});
export type SanityHeroSplit = z.infer<typeof SanityHeroSplit>;

export const heroSplit = groq`{
  theme,
  mediaPosition,
  'backgroundPattern': background,
  eyebrow,
  title,
  bodyCopy,
  "ctaMode": coalesce(ctaMode, "buttons"),
  buttons[] ${cardButton},
  form -> ${form},
  formConfirmation ${formConfirmation},
  "formFunnel": coalesce(formFunnel, "contact"),
  "primaryButtonLabel": coalesce(primaryButtonLabel, "Get a demo"),
  secondaryButton[0] ${link},
  'media': media[0] ${media},
  'mascot': coalesce(mascot, 'none'),
}`;
